// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d7a31f8d","455":"6d431c28","864":"bb4cec6f"}[chunkId] + ".chunk.js";
};